var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site-width"},[_c('form-register',{ref:"form",staticClass:"form form-register",attrs:{"loading":_vm.isProcessing},on:{"submit":_vm.onFormSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }